const inkeep_ai_bot = {
    intro_message: '¡Hola, soy Logto AI!\n\nSoy un asistente de IA entrenado en documentación, artículos de ayuda y otros contenidos.\n\nPregúntame cualquier cosa sobre `Logto`.',
    chat_placeholder: 'Pregunta a Logto AI tu pregunta para obtener una guía paso a paso',
    disclaimer_label: 'Descargo de responsabilidad de Logto AI',
    disclaimer_tooltip: 'Las respuestas son generadas por IA y pueden requerir verificación.',
    example_questions_label: 'Preguntas de ejemplo',
    example_questions: [
        'Guía de inicio rápido para la configuración de Logto',
        'Configurar arquitectura de multi-tenencia',
        '¿Cómo integrar el perfil de usuario?',
    ],
    stop: 'Detener',
    clear: 'Empezar de nuevo',
    get_help: 'Obtener ayuda',
    copy_chat: 'Copiar',
    ask_ai_label: 'Preguntar a la IA',
    contact: 'Contacto',
    discord: 'Discord',
};
export default Object.freeze(inkeep_ai_bot);
